export default "__VITE_ASSET__Cm4K4D4___"